export default __webpack_public_path__ + "static/media/placeholder_pokemon.c1e7bb34.jpg";